// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1RAc2","cell":"ColumnAccessor_cell__KMzjn","firstCellAccent":"ColumnAccessor_firstCellAccent__32NBf"};